import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

const FAQ_ITEMS = [
  { q: 'faq.q1', a: 'faq.a1' },
  { q: 'faq.q2', a: 'faq.a2' },
  { q: 'faq.q3', a: 'faq.a3' },
  { q: 'faq.q4', a: 'faq.a4' },
];

export default function FaqFinalSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      <section id="faq" className="bg-background-100">
        <div className="mx-auto max-w-3xl px-4 py-14 md:px-6 md:py-20">
          <div className="text-center">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              {t('faq.title')}
            </h2>
          </div>

          <div className="mt-8 space-y-3">
            {FAQ_ITEMS.map((item, i) => {
              const isOpen = openIndex === i;
              return (
                <div key={item.q} className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm font-semibold text-foreground-900 md:text-base">
                      {t(item.q)}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-500 transition-transform ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                    >
                      <i className="ri-arrow-down-s-line" />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{t(item.a)}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t('final.title')}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">{t('final.body')}</p>

          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              {t('final.cta_primary')}
              <i className="ri-arrow-right-up-line" />
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 rounded-full border border-foreground-300 px-7 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100 whitespace-nowrap cursor-pointer"
            >
              {t('final.cta_secondary')}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}